/**
 * WhatsApp / wa.me için telefonu uluslararası rakamlara çevirir.
 * TR yerel format: 05xx... → 905xx...
 */
export function normalizeWhatsAppPhone(phone: string | null | undefined): string {
  let digits = String(phone || '').replace(/[^\d]/g, '');
  if (!digits) return '';

  if (digits.startsWith('00')) {
    digits = digits.slice(2);
  }

  // Türkiye yerel: 05xxxxxxxxx (11 hane) → 905xxxxxxxxx
  if (digits.length === 11 && digits.startsWith('0')) {
    digits = `90${digits.slice(1)}`;
  }

  // Türkiye 10 hane (5xxxxxxxxx) → 905xxxxxxxxx
  if (digits.length === 10 && digits.startsWith('5')) {
    digits = `90${digits}`;
  }

  return digits;
}

export function isValidWhatsAppPhone(phone: string | null | undefined): boolean {
  const normalized = normalizeWhatsAppPhone(phone);
  return normalized.length >= 10 && normalized.length <= 15;
}
